import { Component } from '@angular/core'

@Component({
  selector: 'flo-right-rail-list-skeleton',
  templateUrl: './right-rail-list-skeleton.component.html',
  styleUrls: ['./right-rail-list-skeleton.component.scss']
})
export class RightRailListSkeleton {}
